/* eslint-disable react/prop-types */
import React, { useState } from "react";
import Slider from "react-slick";
import { Box, Button, Grid, Modal } from "@mui/material";
import GotLeftImg from "../../assets/Images/CommonImages/GoLeftImg.png";
import GoRightImg from "../../assets/Images/CommonImages/GoRightImg.png";
import { Close } from "@mui/icons-material";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <Box
      component={"img"}
      className={className}
      onClick={onClick}
      sx={{
        ...style,
        display: "block",
        position: "absolute",
        top: "50%",
        left: "-3%",
        height: "auto",
        width: "7%",
        zIndex: "10",
      }}
      src={GotLeftImg}
    ></Box>
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <Box
      component={"img"}
      className={className}
      onClick={onClick}
      sx={{
        ...style,
        display: "block",
        position: "absolute",
        top: "50%",
        right: "-3%",
        height: "auto",
        width: "7%",
        zIndex: "10",
      }}
      src={GoRightImg}
    ></Box>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  px: 4,
  pb: 4,
  borderRadius: "20px",
};

export default function CarasoulForProductDetails(props) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const settings = {
    className: "center",
    beforeChange: (current, next) => setCurrentSlide(next),
    customPaging: function (i) {
      return (
        <a>
          <div>
            <li
              style={{
                border: "3px solid #6B7A99",
                backgroundColor: currentSlide === i ? "#6B7A99" : "white",
                borderRadius: "10px",
                width: "5px",
                height: "5px",
              }}
            ></li>
          </div>
        </a>
      );
    },
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 1,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    touchMove: true,
    dots: true,
  };

  return (
    <Grid
      sx={{
        width: "100%",
        maxWidth: "450px",
        mx: "auto",
        position: "relative",
      }}
      gap={5}
    >
      <Slider {...settings}>
        <Box onClick={() => handleOpen()} sx={{ cursor: "pointer" }}>
          <img src={props?.imgSrc?.at(0)?.url} style={ImageStyle} />
        </Box>
        <Box onClick={() => handleOpen()} sx={{ cursor: "pointer" }}>
          <img src={props?.imgSrc?.at(1)?.url} style={ImageStyle} />
        </Box>
      </Slider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
          >
            <Button onClick={() => handleClose()}>
              <Close fontSize="large" />
            </Button>
          </Box>
          <Slider {...settings}>
            <Box onClick={() => handleOpen()} sx={{ cursor: "pointer" }}>
              <img src={props?.imgSrc?.at(0)?.url} style={ImageStyleTwo} />
            </Box>
            <Box onClick={() => handleOpen()} sx={{ cursor: "pointer" }}>
              <img src={props?.imgSrc?.at(1)?.url} style={ImageStyleTwo} />
            </Box>
          </Slider>
        </Box>
      </Modal>
    </Grid>
  );
}

const ImageStyle = {
  width: "98%",
  borderRadius: "10px",
  maxWidth: "450px",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  textAlign: "center",
};

const ImageStyleTwo = {
  width: "100%",
  borderRadius: "10px",
  maxWidth: "600px",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  textAlign: "center",
};
